(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["et-brand-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    root.querySelectorAll('.et-brands').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const viewport = section.querySelector('.et-brands__viewport');
      const list = section.querySelector('.et-brands__list');
      const button = section.querySelector('.et-brands__pause');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches, hovering = false, focused = false, visible = false, previous = 0, position = 0;
      button.hidden = false;
      function update() {
        button.setAttribute('aria-pressed', String(paused));
        button.textContent = paused ? button.dataset.play : button.dataset.pause;
      }
      button.addEventListener('click', () => { paused = !paused; update(); });
      viewport.addEventListener('mouseenter', () => { hovering = true; });
      viewport.addEventListener('mouseleave', () => { hovering = false; });
      viewport.addEventListener('focusin', () => { focused = true; });
      viewport.addEventListener('focusout', event => { focused = viewport.contains(event.relatedTarget); });
      viewport.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse') { paused = true; update(); } }, {passive:true});
      motion.addEventListener('change', () => { paused = motion.matches; update(); });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      observer.observe(section);
      function frame(now) {
        if (!section.isConnected) { observer.disconnect(); return; }
        const elapsed = previous ? Math.min(now - previous, 60) : 0;
        previous = now;
        if (visible && !document.hidden && !paused && !hovering && !focused && !motion.matches) {
          const width = list.getBoundingClientRect().width;
          if (width) {
            if (Math.abs(viewport.scrollLeft - position) > 2) position = viewport.scrollLeft;
            position = (position + elapsed * 0.03) % width;
            viewport.scrollLeft = position;
          }
        }
        requestAnimationFrame(frame);
      }
      update();
      requestAnimationFrame(frame);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-modal"]) return;
  try {
    
  if (!customElements.get('et-offer-popup')) {
    customElements.define('et-offer-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || this.initialized) return;
        this.initialized = true;
        this.editor = this.dataset.editor === 'true';
        this.querySelector('button').addEventListener('click', () => this.dismiss());
        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.dismiss();
        });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dismiss();
        });
        this.dialog.addEventListener('close', () => this.restoreScroll());
        if (!this.editor && document.cookie.split(';').some((part) => part.trim().startsWith('site_popup_shown='))) return;
        this.timer = setTimeout(() => this.show(), Number(this.dataset.delay) || 0);
      }
      show() {
        if (!this.isConnected || this.dialog.open) return;
        const image = this.querySelector('img');
        if (!image.complete) {
          image.addEventListener('load', () => this.show(), { once: true });
          return;
        }
        if (!image.naturalWidth) return;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        this.dialog.showModal();
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (this.dialog.open) this.dialog.classList.add('is-visible');
        }));
      }
      dismiss() {
        if (!this.dialog.open || this.closing) return;
        this.closing = true;
        if (!this.editor) document.cookie = 'site_popup_shown=1; Max-Age=86400; Path=/; SameSite=Lax; Secure';
        this.dialog.classList.remove('is-visible');
        const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450;
        this.closeTimer = setTimeout(() => {
          this.dialog.close();
          this.closing = false;
        }, duration);
      }
      restoreScroll() {
        if (this.locked) document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        clearTimeout(this.closeTimer);
        if (this.dialog?.open) this.dialog.close();
        this.restoreScroll();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
